/* eslint-disable no-plusplus */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable consistent-return */
/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Overlay } from 'react-bootstrap';
import { FormattedMessage, useIntl } from 'react-intl';
import add from 'date-fns/add';
import {
  MdOutlineSwapHoriz,
  MdCalendarToday,
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
  MdEast,
  MdOutlineCancel,
  MdAddCircleOutline,
  MdOutlineRemoveCircleOutline,
  MdOutlineSwapVert,
  MdCalendarMonth,
} from 'react-icons/md';
import { RiSignalWifiErrorLine } from 'react-icons/ri';
import { PiHandTap } from 'react-icons/pi';
import { TbWorldSearch } from 'react-icons/tb';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import './FlightLandingPage.scss';
import AppRadioInput from '../../shared/components/app-radio-input/AppRadioInput';
import AppAsyncSelect from '../../shared/components/app-async-select/AppAsyncSelect';
import AppDatePicker from '../../shared/components/app-date-picker/AppDatePicker';
import { getAirportsApi, getRecentAirports } from '../../api/flightApi';
import { mobileCheck, debounce } from '../../api/apiUtils';
import {
  API_DATE_FORMAT,
  NAVIGATION_ROUTES,
  TODAY_DATE,
  YEAR_MONTH_DATE_WITHOUT_SEPERATION,
} from '../../shared/constants/Constants';
import {
  formatDate,
  isSameDate,
  isAfterDate,
  isMobileWidth,
  getNewDate,
} from '../../shared/helper-utils/appUtils';
import AppButton from '../../shared/components/app-button/AppButton';
import AppLink from '../../shared/components/app-link/AppLink';
import AppSelect from '../../shared/components/app-select/AppSelect';
import AppCheckBox from '../../shared/components/app-check-box/AppCheckBox';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import AppIconButton from '../../shared/components/app-icon-button/AppIconButton';
import { getAirportNameByCode } from '../../shared/constants/AirportsName';
import { useAppContext } from '../../saas/AppConfigWrapper';

const DEBOUNCE_DELAY = 500;

export const PREF_CLASS_DICT = {
  Y: 'economy',
  W: 'premium_economy',
  C: 'business',
  F: 'first_class',
};

const PREF_AIRLINE_OPTIONS = [
  { label: 'All Airlines', value: 'All' },
  { label: 'Air India(AI)', value: 'AI' },
  { label: 'Akasa Air(QP)', value: 'QP' },
  { label: 'Indigo(6E)', value: '6E' },
  { label: 'Air Asia(I5)', value: 'I5' },
  { label: 'Vistara(UK)', value: 'UK' },
  { label: 'Spice Jet(SG)', value: 'SG' },
  { label: 'Go Airlines(G8)', value: 'G8' },
  { label: 'Fly Big(S9)', value: 'S9' },
  { label: 'Alliance Air(9I)', value: '9I' },
  { label: 'Star Air(S5)', value: 'S5' },
  { label: 'AIr India Express(IX)', value: 'IX' },
  { label: 'GDS Carriers only(GDS)', value: 'GDS' },
];

const NUMPAX_DICT = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

export function AirportOption(props) {
  return (
    <div
      onClick={() => props.selectOption(props.data)}
      className={`${props.isFocused ? 'airport-focused' : ''} airport-option`}
      key={props.value}
    >
      <div className="d-flex justify-content-between p-1">
        <div className="airport-city-details">
          <div className="fs-14 d-flex align-items-center">
            <span className="airport-option_country-code">
              {props.data.AirportCode}
            </span>
            <span>{props.data.AirportLocation.split(',')[0]}</span>
          </div>
          <div className="airport-option_airport-name">
            {getAirportNameByCode(props.data.AirportCode)}
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-end fs-12 airport-country-details gap-1">
          <span>{props.data.Country}</span>
          <img
            src={`https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/${props.data.CountryCode.toLowerCase()}.svg`}
          />
        </div>
      </div>
    </div>
  );
}

function FlightLandingPage({
  previousSearchRequest,
  isModifySearch,
  onModifySearch,
}) {
  const { appConfig } = useAppContext();
  const navigate = useNavigate();
  const intl = useIntl();
  const [errors, setErrors] = useState({
    origin: '',
    destination: '',
    onwarddate: '',
    returndate: '',
    multiCity: [
      {
        origin: '',
        destination: '',
        onwarddate: '',
      },
      {
        origin: '',
        destination: '',
        onwarddate: '',
      },
    ],
  });
  const isApiRequestProcessingRef = useRef(false);
  const [defaultAirportsList, setDefaultAirportsList] = useState([]);
  const originAirportRef = useRef(null);
  const destinationAirportRef = useRef(null);
  const passengersOverlayTarget = useRef(null);
  const [openPassengers, setOpenPassengers] = useState(false);
  const isMobileView = useRef(false);
  const [showAdvanceSearch, setShowAdvanceSearch] = useState(false);
  const [alert, setAlert] = useState(undefined);
  const [search, setSearch] = useState({
    flightsearchrequest: {
      origin: '',
      destination: '',
      onwarddate: getNewDate(TODAY_DATE),
      returndate: '',
      numadults: '1',
      numchildren: '0',
      numinfants: '0',
      journeytype: 'OneWay',
      prefclass: 'Y',
      requestformat: 'JSON',
      resultformat: 'JSON',
      searchtype: 'normal',
      sortkey: '',
      issbt: 'false',
      profileid: '',
      numresults: 100,
      actionname: 'FLIGHTSEARCH',
      preddeptimewindow: null,
      prefarrtimewindow: null,
      prefcarrier: 'All',
      prefcarrierall: 'All',
      excludecarriers: '',
      refundtype: 'All',
      layovertime: '',
      promocode: '',
      nonstopsearch: 'false',
      multiCitySearch: [
        {
          origin: '',
          destination: '',
          onwarddate: getNewDate(TODAY_DATE),
          selectedOrigin: '',
          selectedDestination: '',
        },
        {
          origin: '',
          destination: '',
          onwarddate: '',
          selectedOrigin: '',
          selectedDestination: '',
        },
      ],
    },
  });

  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };

  useEffect(() => {
    if (
      previousSearchRequest &&
      Object.keys(previousSearchRequest).length > 0
    ) {
      originAirportRef.current = {
        label: `${previousSearchRequest.originLocation} - ${previousSearchRequest.origin}`,
        AirportLocation: previousSearchRequest.originLocation,
        value: previousSearchRequest.origin,
        Country: previousSearchRequest.originLocation.split(',').pop().trim(),
      };
      destinationAirportRef.current = {
        label: `${previousSearchRequest.destinationLocation} - ${previousSearchRequest.destination}`,
        AirportLocation: previousSearchRequest.destinationLocation,
        value: previousSearchRequest.destination,
        Country: previousSearchRequest.destinationLocation
          .split(',')
          .pop()
          .trim(),
      };
      setSearch((prevState) => ({
        ...prevState,
        flightsearchrequest: {
          ...prevState.flightsearchrequest,
          origin: previousSearchRequest.origin,
          destination: previousSearchRequest.destination,
          numadults: previousSearchRequest.numadults,
          numchildren: previousSearchRequest.numchildren,
          numinfants: previousSearchRequest.numinfants,
          journeytype: previousSearchRequest.journeytype,
          returndate:
            previousSearchRequest.returndate !== undefined
              ? getNewDate(previousSearchRequest.returndate)
              : '',
          searchtype: previousSearchRequest.searchtype,
          onwarddate: getNewDate(previousSearchRequest.onwarddate),
          promocode: previousSearchRequest.promocode,
          prefclass: previousSearchRequest.prefclass,
          prefcarrier: previousSearchRequest.prefcarrier,
          prefcarrierall: previousSearchRequest.prefcarrierall,
        },
      }));
    }
  }, [previousSearchRequest]);

  const getLabel = (airport) => {
    return isMobileWidth() ? (
      <div className="d-flex flex-column">
        <span style={{ fontSize: '14px', fontWeight: '600', color: '#1E1E1E' }}>
          {airport.AirportLocation.split(',')[0]}
        </span>
        <span
          style={{
            fontSize: '10px',
            fontWeight: '400',
            color: '5B5B5B',
            marginTop: '-4px',
          }}
        >
          {airport.AirportCode}
        </span>
      </div>
    ) : (
      <div className="d-flex flex-column mt-1">
        <span style={{ fontSize: '20px', fontWeight: '600', color: '#1E1E1E' }}>
          {airport.AirportLocation.split(',')[0]}
        </span>
        <span style={{ fontSize: '16px', fontWeight: '400', color: '5B5B5B' }}>
          {airport.AirportCode}
        </span>
      </div>
    );
  };

  const handleUpdateSearchState = (name, value) => {
    if (
      search.flightsearchrequest.searchtype === 'seniorcitizen' ||
      search.flightsearchrequest.searchtype === 'student' ||
      search.flightsearchrequest.searchtype === 'defenceonly'
    ) {
      if (name === 'numchildren' || name === 'numinfants') {
        setAlert({
          title: 'Flight Search',
          description: 'Children and Infants are not allowed for this booking',
          variant: 'error',
        });
        return false;
      }
    }
    if (name === 'searchtype' && value !== 'normal') {
      setSearch((prev) => ({
        ...prev,
        flightsearchrequest: {
          ...prev.flightsearchrequest,
          numchildren: '0',
          numinfants: '0',
        },
      }));
    }
    if (name === 'prefcarrier') {
      setSearch((prevState) => ({
        ...prevState,
        flightsearchrequest: {
          ...prevState.flightsearchrequest,
          prefcarrierall: value,
        },
      }));
    }
    setSearch((prevState) => ({
      ...prevState,
      flightsearchrequest: {
        ...prevState.flightsearchrequest,
        [name]: value,
      },
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: undefined,
    }));
  };

  const getDefaultAirports = async () => {
    if (!isApiRequestProcessingRef.current) {
      isApiRequestProcessingRef.current = true;
      const response = await getRecentAirports(appConfig?.companyName);
      if (
        response &&
        response.ApiStatus &&
        response.ApiStatus.Status === 'OK'
      ) {
        const { Result } = response.ApiStatus;
        let { AirportDetail } = Result;
        AirportDetail = Array.isArray(AirportDetail)
          ? AirportDetail
          : [AirportDetail];
        AirportDetail.forEach((airport) => {
          airport.label = getLabel(airport);
          airport.value = airport.AirportCode;
        });
        if (appConfig?.showSectorSuggestions === 'true') {
          setDefaultAirportsList(AirportDetail);
        }
        if (appConfig.showDefaultSectors === 'true') {
          if (
            originAirportRef.current === null &&
            destinationAirportRef.current === null
          ) {
            [originAirportRef.current, destinationAirportRef.current] =
              AirportDetail;
            handleUpdateSearchState(
              'origin',
              originAirportRef.current.AirportCode,
            );
            handleUpdateSearchState(
              'destination',
              destinationAirportRef.current.AirportCode,
            );
            setSearch((prevState) => ({
              ...prevState,
              flightsearchrequest: {
                ...prevState.flightsearchrequest,
                multiCitySearch: [
                  {
                    origin: AirportDetail[0].AirportCode,
                    destination: AirportDetail[1].AirportCode,
                    onwarddate: getNewDate(TODAY_DATE),
                    selectedOrigin: AirportDetail[0],
                    selectedDestination: AirportDetail[1],
                  },
                  {
                    origin: AirportDetail[1].AirportCode,
                    destination: '',
                    onwarddate: '',
                    selectedOrigin: AirportDetail[1],
                    selectedDestination: '',
                  },
                ],
              },
            }));
          }
        }
      }
    }
  };

  useEffect(() => {
    getDefaultAirports();
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === 'journeytype' && value === 'OneWay') {
      handleUpdateSearchState('returndate', '');
    }
    handleUpdateSearchState(name, value);
  };

  const loadAirportSuggestions = debounce(async (query, callback) => {
    let airports = [];
    if (query.length >= 3) {
      const response = await getAirportsApi(query);
      airports = response.map((airportNode) => ({
        label: getLabel(airportNode),
        value: airportNode.AirportCode,
        ...airportNode,
      }));
    }
    callback(airports);
  }, DEBOUNCE_DELAY);

  const handleAirportSelect = (airport, name) => {
    if (name === 'origin') {
      originAirportRef.current = airport;
      let originAirportCode = '';
      if (airport !== null) {
        originAirportCode = airport.value;
      }
      handleUpdateSearchState('origin', originAirportCode);
    } else {
      destinationAirportRef.current = airport;
      let destinationAirportCode = '';
      if (airport !== null) {
        destinationAirportCode = airport.value;
      }
      handleUpdateSearchState('destination', destinationAirportCode);
    }
  };

  const handleSwap = () => {
    const tempOrigin = search.flightsearchrequest.origin;
    const tempOriginDetail = originAirportRef.current;

    handleUpdateSearchState('origin', search.flightsearchrequest.destination);
    handleUpdateSearchState('destination', tempOrigin);
    originAirportRef.current = destinationAirportRef.current;
    destinationAirportRef.current = tempOriginDetail;
  };

  const handleDateChange = (date, fieldName) => {
    if (fieldName === 'returndate') {
      handleUpdateSearchState('journeytype', 'RoundTrip');
    }
    handleUpdateSearchState(fieldName, date);
  };

  const handleClearReturnDate = () => {
    setSearch((prevState) => ({
      ...prevState,
      flightsearchrequest: {
        ...prevState.flightsearchrequest,
        returndate: '',
        journeytype: 'OneWay',
      },
    }));
  };

  const handlePassengersSelection = () => {
    setOpenPassengers(false);
  };

  const handleFlightSearch = () => {
    let isErrorExist = false;
    const errorsObj = {
      origin: '',
      destination: '',
      onwarddate: '',
      returndate: '',
      multiCity: [],
    };
    const searchRequest = { ...search.flightsearchrequest };
    if (searchRequest.numinfants > searchRequest.numadults) {
      setAlert({
        title: 'Flight Search',
        description: 'Number of infants cannot be more than adults',
        variant: 'error',
      });
      return false;
    }
    if (
      searchRequest.searchtype === 'seniorcitizen' ||
      searchRequest.searchtype === 'student'
    ) {
      if (
        parseInt(searchRequest.numinfants, 10) > 0 ||
        parseInt(searchRequest.numchildren, 10) > 0
      ) {
        setAlert({
          title: 'Flight Search',
          description: 'Children and Infants are not allowed for this booking',
          variant: 'error',
        });
        return false;
      }
    }
    if (searchRequest.journeytype !== 'MultiCity') {
      if (searchRequest.origin === '') {
        errorsObj.origin = formattedMessage('origin_validation');
        isErrorExist = true;
      }
      if (searchRequest.destination === '') {
        errorsObj.destination = formattedMessage('destination_validation');
        isErrorExist = true;
      }
      if (
        searchRequest.origin &&
        searchRequest.origin === searchRequest.destination
      ) {
        errorsObj.destination = formattedMessage(
          'same_origin_destination_validation',
        );
        isErrorExist = true;
      }
      if (
        searchRequest.onwarddate === null ||
        searchRequest.onwarddate === undefined ||
        searchRequest.onwarddate === ''
      ) {
        errorsObj.onwarddate = formattedMessage('onward_date_validation');
        isErrorExist = true;
      }
      if (
        searchRequest.journeytype === 'RoundTrip' &&
        (searchRequest.returndate === null ||
          searchRequest.returndate === undefined ||
          searchRequest.returndate === '')
      ) {
        errorsObj.returndate = formattedMessage('return_date_validation');
        isErrorExist = true;
      }

      searchRequest.onwarddate = formatDate(
        searchRequest.onwarddate,
        API_DATE_FORMAT,
      );
      if (
        searchRequest.returndate !== '' &&
        searchRequest.returndate !== undefined
      ) {
        searchRequest.returndate = formatDate(
          searchRequest.returndate,
          API_DATE_FORMAT,
        );
        if (
          !isSameDate(
            getNewDate(searchRequest.onwarddate),
            getNewDate(searchRequest.returndate),
          ) &&
          isAfterDate(
            getNewDate(searchRequest.onwarddate),
            getNewDate(searchRequest.returndate),
          )
        ) {
          errorsObj.onwaredDateAfterReturnDate = formattedMessage(
            'return_onward_date_validation',
          );
          isErrorExist = true;
        }
      } else {
        searchRequest.returndate = null;
      }
    } else {
      searchRequest.multiCitySearch.forEach((d, index) => {
        const error = {};
        if (d.origin === '') {
          error.origin = 'Please select origin.';
          isErrorExist = true;
        }
        if (
          d.destination === '' ||
          d.destination === undefined ||
          d.destination === null
        ) {
          error.destination = 'Please select destination.';
          isErrorExist = true;
        }
        if (d.origin && d.origin === d.destination) {
          error.destination = 'Origin and Destination cant be same.';
          isErrorExist = true;
        }
        if (
          d.onwarddate === null ||
          d.onwarddate === undefined ||
          d.onwarddate === ''
        ) {
          error.onwarddate = 'Select journey date.';
          isErrorExist = true;
        }
        if (index !== 0) {
          if (
            d.onwarddate !== null &&
            d.onwarddate !== undefined &&
            d.onwarddate !== '' &&
            searchRequest.multiCitySearch[index - 1].onwarddate.onwarddate !==
              null &&
            searchRequest.multiCitySearch[index - 1].onwarddate.onwarddate !==
              undefined &&
            searchRequest.multiCitySearch[index - 1].onwarddate.onwarddate !==
              ''
          )
            if (
              isAfterDate(
                getNewDate(searchRequest.multiCitySearch[index - 1].onwarddate),
                getNewDate(d.onwarddate),
              )
            ) {
              error.onwarddate = 'Date is less than previous journey';
              isErrorExist = true;
            }
        }
        errorsObj.multiCity.push(error);
      });
    }
    setErrors(errorsObj);
    if (isErrorExist) {
      return true;
    }
    if (searchRequest.journeytype === 'MultiCity') {
      if (
        searchRequest.searchtype !== 'normal' &&
        searchRequest.searchtype !== 'seriesfares'
      ) {
        setAlert({
          title: 'Flight Search',
          variant: 'error',
          description:
            'Multi City search is only available for normal search type',
        });
        return false;
      }
      const originArr = [];
      const destinationArr = [];
      const dateArr = [];
      const originLocationsArr = [];
      const destinationLocationsArr = [];
      let isIntlSearch = false;
      searchRequest.multiCitySearch.forEach((sector) => {
        originArr.push(sector.origin);
        destinationArr.push(sector.destination);
        const formattedDate = formatDate(
          getNewDate(sector.onwarddate),
          YEAR_MONTH_DATE_WITHOUT_SEPERATION,
        );
        dateArr.push(formattedDate);
        originLocationsArr.push(sector.selectedOrigin.AirportLocation);
        destinationLocationsArr.push(
          sector.selectedDestination.AirportLocation,
        );
        if (
          (sector.selectedOrigin.Country !== '' &&
            sector.selectedOrigin.Country.toLowerCase() !== 'india') ||
          (sector.selectedDestination.Country !== '' &&
            sector.selectedDestination.Country.toLowerCase() !== 'india')
        ) {
          isIntlSearch = true;
        }
      });
      const numsectors = searchRequest.multiCitySearch.length;
      const queryParam = `origin=${originArr.join(
        ':',
      )}&destination=${destinationArr.join(':')}&onwarddate=${dateArr.join(
        ':',
      )}&numadults=${searchRequest.numadults}&numchildren=${
        searchRequest.numchildren
      }&numinfants=${
        searchRequest.numinfants
      }&originlocations=${originLocationsArr.join(':')}&prefclass=${
        searchRequest.prefclass
      }&journeytype=${searchRequest.journeytype}&searchtype=${
        searchRequest.searchtype
      }&promocode=${
        searchRequest.promocode
      }&destinationlocations=${destinationLocationsArr.join(
        ':',
      )}&numsectors=${numsectors}&nonstopsearch=${searchRequest.nonstopsearch}`;
      if (isIntlSearch) {
        navigate(
          `${NAVIGATION_ROUTES.FLIGHT.INTL_MULTICITY_RESULTS_ROUTE}?${queryParam}`,
        );
        return;
      }
      navigate(
        `${NAVIGATION_ROUTES.FLIGHT.DOM_MULTICITY_RESULTS_ROUTE}?${queryParam}`,
      );
      return;
    }
    if (
      searchRequest.searchtype !== 'normal' &&
      searchRequest.searchtype !== 'seriesfares'
    ) {
      // if (
      //   (originAirportRef.current.Country !== '' &&
      //     originAirportRef.current.Country.toLowerCase() !== 'india') ||
      //   (destinationAirportRef.current.Country !== '' &&
      //     destinationAirportRef.current.Country.toLowerCase() !== 'india')
      // ) {
      //   return;
      // }
    }
    let queryParam = `origin=${searchRequest.origin}&originLocation=${originAirportRef.current.AirportLocation}&destination=${searchRequest.destination}&destinationLocation=${destinationAirportRef.current.AirportLocation}&onwarddate=${searchRequest.onwarddate}`;
    if (searchRequest.returndate !== null) {
      queryParam += `&returndate=${searchRequest.returndate}`;
    }
    let dpt = '';
    if (
      searchRequest.preddeptimewindow !== null &&
      searchRequest.preddeptimewindow !== ''
    ) {
      dpt = searchRequest.preddeptimewindow.value
        ? searchRequest.preddeptimewindow.value
        : searchRequest.preddeptimewindow;
    }
    queryParam += `&numadults=${searchRequest.numadults}&numchildren=${searchRequest.numchildren}&numinfants=${searchRequest.numinfants}&prefclass=${searchRequest.prefclass}&prefcarrier=${searchRequest.prefcarrier}&journeytype=${searchRequest.journeytype}&preddeptimewindow=${dpt}&searchtype=${searchRequest.searchtype}&promocode=${searchRequest.promocode}&nonstopsearch=${searchRequest.nonstopsearch}&prefcarrierall=${searchRequest.prefcarrierall}`;
    if (searchRequest.journeytype === 'OneWay') {
      if (isModifySearch) {
        onModifySearch();
      }
      navigate(
        `${NAVIGATION_ROUTES.FLIGHT.ONE_WAY_FLIGHT_RESULTS_ROUTE}?${queryParam}`,
      );
    } else if (
      (originAirportRef.current.Country !== '' &&
        originAirportRef.current.Country.toLowerCase() !== 'india') ||
      (destinationAirportRef.current.Country !== '' &&
        destinationAirportRef.current.Country.toLowerCase() !== 'india')
    ) {
      navigate(
        `${NAVIGATION_ROUTES.FLIGHT.INTERNATIONAL_ROUND_TRIP_FLIGHT_RESULTS_ROUTE}?${queryParam}`,
      );
    } else {
      navigate(
        `${NAVIGATION_ROUTES.FLIGHT.ROUND_TRIP_FLIGHT_RESULTS_ROUTE}?${queryParam}`,
      );
    }
  };

  const handleMultiCityChange = (data, name, index) => {
    const multiCitySearch = [...search.flightsearchrequest.multiCitySearch];
    const errorList = errors.multiCity || [];
    if (name === 'origin') {
      multiCitySearch[index].origin = data.value;
      multiCitySearch[index].selectedOrigin = data;
      errorList[index].origin = undefined;
    } else if (name === 'destination') {
      multiCitySearch[index].destination = data.value;
      multiCitySearch[index].selectedDestination = data;
      errorList[index].destination = undefined;
    } else if (name === 'onwarddate') {
      multiCitySearch[index].onwarddate = getNewDate(data);
      for (let i = 0; i < multiCitySearch.length; i++) {
        if (i > index) {
          multiCitySearch[i].onwarddate = '';
        }
      }
      errorList[index].onwarddate = undefined;
    }
    setSearch({
      ...search,
      flightsearchrequest: { ...search.flightsearchrequest, multiCitySearch },
    });
    setErrors({ ...errors, multiCity: errorList });
  };

  const onRemoveMultiCityRow = (index) => {
    const multiCitySearch = [...search.flightsearchrequest.multiCitySearch];
    const errorList = errors.multiCity || [];
    multiCitySearch.splice(index, 1);
    errorList.splice(index, 1);
    setSearch({
      ...search,
      flightsearchrequest: { ...search.flightsearchrequest, multiCitySearch },
    });
    setErrors({ ...errors, multiCity: errorList });
  };

  const handleNonStopSelect = () => {
    const isNonStop =
      search.flightsearchrequest.nonstopsearch === 'false' ? 'true' : 'false';
    handleUpdateSearchState('nonstopsearch', isNonStop);
  };

  const onAddMultiCityRow = () => {
    const multiCitySearch = [...search.flightsearchrequest.multiCitySearch];
    if (multiCitySearch.length === 5) {
      setAlert({
        title: 'Multi City Search',
        description: 'More than 5 flights are not allowed',
        variant: 'error',
      });
      return;
    }
    const errorList = errors.multiCity || [];
    let obj = {};
    if (
      multiCitySearch[multiCitySearch.length - 1].destination !== '' &&
      multiCitySearch[multiCitySearch.length - 1].destination !== null &&
      multiCitySearch[multiCitySearch.length - 1].destination !== undefined
    ) {
      obj = {
        origin: multiCitySearch[multiCitySearch.length - 1].destination,
        destination: '',
        onwarddate: '',
        selectedOrigin:
          multiCitySearch[multiCitySearch.length - 1].selectedDestination,
      };
    } else {
      obj = {
        origin: '',
        destination: '',
        onwarddate: '',
      };
    }
    multiCitySearch.push(obj);
    errorList.push({ onwarddate: '', origin: '', destination: '' });
    setSearch({
      ...search,
      flightsearchrequest: { ...search.flightsearchrequest, multiCitySearch },
    });
    setErrors({ ...errors, multiCity: errorList });
  };
  const handleRemovePassengers = (name) => {
    const numPax = parseInt(search.flightsearchrequest[name], 10);
    if (name === 'numadults') {
      if (numPax === 1) {
        return;
      }
      handleUpdateSearchState(name, parseInt(numPax, 10) - 1);
    } else {
      if (numPax === 0) {
        return;
      }
      handleUpdateSearchState(name, parseInt(numPax, 10) - 1);
    }
  };

  const handleChangejourneytype = (name, value) => {
    if (name === 'journeytype' && value === 'OneWay') {
      handleUpdateSearchState('returndate', '');
    }
    if (name === 'journeytype' && value === 'RoundTrip') {
      if (search.flightsearchrequest.returndate === '') {
        handleUpdateSearchState(
          'returndate',
          add(getNewDate(search.flightsearchrequest.onwarddate), { days: 1 }),
        );
      }
    }
    handleUpdateSearchState(name, value);
  };

  const handleAddPassengers = (name) => {
    const numPax = parseInt(search.flightsearchrequest[name], 10);
    if (
      search.flightsearchrequest.searchtype === 'seniorcitizen' ||
      search.flightsearchrequest.searchtype === 'student' ||
      search.flightsearchrequest.searchtype === 'defenceonly'
    ) {
      if (name === 'numchildren' || name === 'numinfants') {
        setAlert({
          title: 'Flight Search',
          description: 'Children and Infants are not allowed for this booking',
          variant: 'error',
        });
        return false;
      }
    }
    handleUpdateSearchState(name, parseInt(numPax, 10) + 1);
  };

  const handlePrefClassChange = (prefclass) => {
    setSearch((prevState) => ({
      ...prevState,
      flightsearchrequest: {
        ...prevState.flightsearchrequest,
        prefclass,
      },
    }));
  };

  return (
    <div className="flight-landing-page">
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      {!isMobileWidth() ? (
        <div className="flight-landing-page_container">
          <div className="flight-landing-page_search">
            <div className="flight-landing-page_search_container">
              <div className="flight-landing-page_search_radio-container d-flex gap-3">
                <AppRadioInput
                  id="OneWay"
                  name="journeytype"
                  labelText={formattedMessage('oneway_btn')}
                  value="OneWay"
                  onChange={handleChange}
                  checked={search.flightsearchrequest.journeytype === 'OneWay'}
                />
                <AppRadioInput
                  id="RoundTrip"
                  name="journeytype"
                  labelText={formattedMessage('roundtrip_btn')}
                  value="RoundTrip"
                  onChange={handleChange}
                  checked={
                    search.flightsearchrequest.journeytype === 'RoundTrip'
                  }
                />
                {appConfig?.hasMultiCity && (
                  <AppRadioInput
                    labelText="Multi city"
                    id="MultiCity"
                    name="journeytype"
                    value="MultiCity"
                    onChange={handleChange}
                    checked={
                      search.flightsearchrequest.journeytype === 'MultiCity'
                    }
                  />
                )}
                {appConfig.hasGroupbooking && (
                  <AppRadioInput
                    labelText="Group Booking"
                    id="groupbooking"
                    name="journeytype"
                    value="groupbooking"
                    onChange={() => navigate('/flight/agent-support')}
                  />
                )}
              </div>
              <Row className="flight-landng-page_search_request">
                <Col lg={9} md={9} sm={12} xs={12}>
                  {search.flightsearchrequest.journeytype !== 'MultiCity' ? (
                    <Row>
                      <Col lg={6} md={6} sm={12} xs={12}>
                        <Row className="spacing-1 mb-sm-0 mb-2">
                          <Col
                            lg={6}
                            md={6}
                            sm={6}
                            xs={6}
                            className="position-relative"
                          >
                            <AppAsyncSelect
                              placeholder=""
                              name="origin"
                              components={{ Option: AirportOption }}
                              selectedValue={originAirportRef.current}
                              loadOptionsFn={loadAirportSuggestions}
                              defaultOptions={defaultAirportsList}
                              onSelect={handleAirportSelect}
                              label={formattedMessage('depart_from')}
                              menuWidth="320px !important"
                              height={isMobileWidth() ? '54px' : undefined}
                              padding={isMobileWidth() ? '8px 14px' : undefined}
                            />
                            <small className="validation-error">
                              {errors.origin && errors.origin}
                            </small>
                            <div className="d-flex justify-content-center align-items-center origin-swap">
                              <button
                                onClick={handleSwap}
                                className="d-flex justify-content-center align-items-center"
                              >
                                <MdOutlineSwapHoriz
                                  style={{
                                    color: appConfig?.clientPrimaryColor,
                                    margin: 'auto',
                                  }}
                                />
                              </button>
                            </div>
                          </Col>
                          <Col lg={6} md={6} sm={6} xs={6}>
                            <AppAsyncSelect
                              placeholder=""
                              name="destination"
                              components={{ Option: AirportOption }}
                              selectedValue={destinationAirportRef.current}
                              loadOptionsFn={loadAirportSuggestions}
                              defaultOptions={defaultAirportsList}
                              onSelect={handleAirportSelect}
                              label={formattedMessage('going_to')}
                              menuWidth="320px !important"
                              height={isMobileWidth() ? '54px' : undefined}
                              padding={isMobileWidth() ? '8px 14px' : undefined}
                              menuStartFromRight={isMobileWidth()}
                            />
                            <small className="validation-error">
                              {errors.destination && errors.destination}
                            </small>
                          </Col>
                        </Row>
                      </Col>
                      <Col lg={6} md={6} sm={12} xs={12}>
                        <Row className="spacing-1  mb-sm-0 mb-2">
                          <Col lg={6} md={6} sm={6} xs={6}>
                            <AppDatePicker
                              customClassName="app-landing-datepicker"
                              label={formattedMessage('depart_date')}
                              labelClassName="landing-datepicker-label"
                              minDate={getNewDate(TODAY_DATE)}
                              monthsShown={isMobileWidth() ? 12 : 2}
                              dateFormat="dd MMM yy"
                              selectedDate={
                                search.flightsearchrequest.onwarddate
                              }
                              onChange={(date) =>
                                handleDateChange(date, 'onwarddate')
                              }
                              showDay={isMobileWidth() ? false : true}
                            />
                            <small className="validation-error">
                              {errors.onwarddate && errors.onwarddate}
                            </small>
                          </Col>
                          <Col
                            lg={6}
                            md={6}
                            sm={6}
                            xs={6}
                            className="position-relative"
                          >
                            <AppDatePicker
                              customClassName="app-landing-datepicker"
                              label={formattedMessage('return_date')}
                              placeholder="--"
                              labelClassName="landing-datepicker-label"
                              minDate={
                                search.flightsearchrequest.onwarddate === ''
                                  ? getNewDate(TODAY_DATE)
                                  : search.flightsearchrequest.onwarddate
                              }
                              monthsShown={isMobileWidth() ? 12 : 1}
                              dateFormat="dd MMM yy"
                              selectedDate={
                                search.flightsearchrequest.returndate
                              }
                              onChange={(date) =>
                                handleDateChange(date, 'returndate')
                              }
                              showDay={
                                search.flightsearchrequest.returndate !== '' &&
                                !isMobileWidth()
                              }
                            />
                            <small className="validation-error">
                              {errors.returndate && errors.returndate}
                              {errors.onwaredDateAfterReturnDate &&
                                errors.onwaredDateAfterReturnDate}
                            </small>
                            {search.flightsearchrequest.returndate !== '' && (
                              <div
                                className="position-absolute clear-return-date"
                                onClick={handleClearReturnDate}
                              >
                                X
                              </div>
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  ) : (
                    <Row className="spacing-8">
                      {search.flightsearchrequest.multiCitySearch.map(
                        (d, index) => (
                          <React.Fragment key={index}>
                            <Col lg={6} md={6} sm={12} xs={12}>
                              <Row className="spacing-1 mb-sm-0 mb-2">
                                <Col
                                  lg={6}
                                  md={6}
                                  sm={6}
                                  xs={6}
                                  className="position-relative"
                                >
                                  <AppAsyncSelect
                                    placeholder=""
                                    name="origin"
                                    components={{ Option: AirportOption }}
                                    selectedValue={d.selectedOrigin}
                                    loadOptionsFn={loadAirportSuggestions}
                                    defaultOptions={defaultAirportsList}
                                    onSelect={(airport, name) =>
                                      handleMultiCityChange(
                                        airport,
                                        name,
                                        index,
                                      )
                                    }
                                    label={formattedMessage('depart_from')}
                                    menuWidth="320px !important"
                                    height={
                                      isMobileWidth() ? '54px' : undefined
                                    }
                                    padding={
                                      isMobileWidth() ? '8px 14px' : undefined
                                    }
                                  />
                                  <small className="validation-error">
                                    {errors.multiCity[index]?.origin &&
                                      errors.multiCity[index].origin}
                                  </small>
                                </Col>
                                <Col lg={6} md={6} sm={6} xs={6}>
                                  <AppAsyncSelect
                                    placeholder=""
                                    name="destination"
                                    components={{ Option: AirportOption }}
                                    selectedValue={d.selectedDestination}
                                    loadOptionsFn={loadAirportSuggestions}
                                    defaultOptions={defaultAirportsList}
                                    onSelect={(airport, name) =>
                                      handleMultiCityChange(
                                        airport,
                                        name,
                                        index,
                                      )
                                    }
                                    label={formattedMessage('going_to')}
                                    menuWidth="320px !important"
                                    height={
                                      isMobileWidth() ? '54px' : undefined
                                    }
                                    padding={
                                      isMobileWidth() ? '8px 14px' : undefined
                                    }
                                    menuStartFromRight={isMobileWidth()}
                                  />
                                  <small className="validation-error">
                                    {errors.multiCity[index]?.destination &&
                                      errors.multiCity[index].destination}
                                  </small>
                                </Col>
                              </Row>
                            </Col>
                            <Col lg={6} md={6} sm={12} xs={12}>
                              <Row>
                                <Col lg={6} md={6} sm={12} xs={12}>
                                  <AppDatePicker
                                    customClassName="app-landing-datepicker"
                                    label={formattedMessage('depart_date')}
                                    labelClassName="landing-datepicker-label"
                                    minDate={
                                      index === 0
                                        ? getNewDate(TODAY_DATE)
                                        : search.flightsearchrequest
                                            .multiCitySearch[index - 1]
                                            .onwarddate
                                    }
                                    monthsShown={isMobileWidth() ? 12 : 2}
                                    dateFormat="dd MMM yy"
                                    selectedDate={d.onwarddate}
                                    onChange={(date) =>
                                      handleMultiCityChange(
                                        date,
                                        'onwarddate',
                                        index,
                                      )
                                    }
                                    showDay={isMobileWidth() ? false : true}
                                  />
                                  <small className="validation-error">
                                    {errors.multiCity[index]?.onwarddate &&
                                      errors.multiCity[index].onwarddate}
                                  </small>
                                </Col>
                                <Col
                                  lg={6}
                                  md={6}
                                  sm={6}
                                  xs={6}
                                  className="d-flex gap-2 fw-600 align-items-center"
                                >
                                  {search.flightsearchrequest.multiCitySearch
                                    .length > 2 &&
                                    [0, 1].indexOf(index) === -1 && (
                                      <AppButton
                                        btnText="Remove"
                                        onClick={() =>
                                          onRemoveMultiCityRow(index)
                                        }
                                        variant="outlined"
                                      />
                                    )}
                                  {index === 0 && (
                                    <AppButton
                                      onClick={onAddMultiCityRow}
                                      btnText="Add City"
                                      variant="secondary"
                                    />
                                  )}
                                </Col>
                              </Row>
                            </Col>
                          </React.Fragment>
                        ),
                      )}
                    </Row>
                  )}
                </Col>
                <Col lg={3} md={3} sm={12} xs={12}>
                  <div
                    className="travellers-class d-flex justify-content-between align-items-center cursor-pointer"
                    ref={passengersOverlayTarget}
                    onClick={() => setOpenPassengers(!openPassengers)}
                  >
                    <div className="d-flex flex-column">
                      <span className="fs-12 travellers-class_label">
                        <FormattedMessage id="travellers" />,{' '}
                        <FormattedMessage id="class" />
                      </span>
                      <span className="travellers-class_text travellersText">
                        {parseInt(search.flightsearchrequest.numadults, 10)}A,
                        {search.flightsearchrequest.numchildren > 0 &&
                          `${parseInt(
                            search.flightsearchrequest.numchildren,
                            10,
                          )}C,`}
                        {search.flightsearchrequest.numinfants > 0 &&
                          `${parseInt(
                            search.flightsearchrequest.numinfants,
                            10,
                          )}I,`}
                        {formattedMessage(
                          PREF_CLASS_DICT[search.flightsearchrequest.prefclass],
                        )}
                      </span>
                    </div>

                    {openPassengers ? (
                      <MdKeyboardArrowUp />
                    ) : (
                      <MdKeyboardArrowDown />
                    )}
                  </div>
                  <Overlay
                    rootClose
                    target={passengersOverlayTarget.current}
                    show={openPassengers}
                    placement="bottom"
                    onHide={() => setOpenPassengers(false)}
                  >
                    {({
                      placement,
                      arrowProps,
                      show: _show,
                      popper,
                      ...props
                    }) => (
                      <div
                        {...props}
                        style={{
                          position: 'absolute',
                          padding: '1rem',
                          borderRadius: '8px',
                          maxWidth: isMobileView.current ? '92%' : '320px',
                          backgroundColor: '#b0d3f6',
                          zIndex: 9999,
                          ...props.style,
                        }}
                        className="travellers-class_overlay"
                      >
                        <div className="d-flex flex-column">
                          <span className="fs-12 fw-600">
                            <FormattedMessage id="adults12" />
                          </span>
                          <div className="my-1">
                            <ul className="num-pax_list d-flex">
                              {NUMPAX_DICT.map(
                                (pax) =>
                                  pax !== '0' && (
                                    <li
                                      key={pax}
                                      className={`${
                                        search.flightsearchrequest.numadults ===
                                        pax
                                          ? 'selected'
                                          : ''
                                      } num-pax_list_item adults`}
                                      onClick={() =>
                                        handleUpdateSearchState(
                                          'numadults',
                                          pax,
                                        )
                                      }
                                    >
                                      {pax}
                                    </li>
                                  ),
                              )}
                            </ul>
                          </div>
                        </div>
                        <div className="d-flex flex-column">
                          <span className="fs-12 fw-600">
                            <FormattedMessage id="children_2_12" />
                          </span>
                          <div className="my-1">
                            <ul className="num-pax_list d-flex">
                              {NUMPAX_DICT.map((pax) => (
                                <li
                                  key={pax}
                                  className={`${
                                    search.flightsearchrequest.numchildren ===
                                    pax
                                      ? 'selected'
                                      : ''
                                  } num-pax_list_item children`}
                                  onClick={() =>
                                    handleUpdateSearchState('numchildren', pax)
                                  }
                                >
                                  {pax}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                        <div className="d-flex flex-column">
                          <span className="fs-12 fw-600">
                            <FormattedMessage id="infant_2" />
                          </span>
                          <div className="my-1">
                            <ul className="num-pax_list d-flex">
                              {NUMPAX_DICT.map((pax) => (
                                <li
                                  key={pax}
                                  className={`${
                                    search.flightsearchrequest.numinfants ===
                                    pax
                                      ? 'selected'
                                      : ''
                                  } num-pax_list_item infants`}
                                  onClick={() =>
                                    handleUpdateSearchState('numinfants', pax)
                                  }
                                >
                                  {pax}
                                </li>
                              ))}
                            </ul>
                          </div>
                        </div>
                        <div className="my-2">
                          <select
                            name="prefclass"
                            id="prefclass"
                            style={{ borderRadius: '3px' }}
                            value={search.flightsearchrequest.prefclass}
                            onChange={handleChange}
                            className="fs-14 fs-600 w-100 py-1"
                          >
                            <option value="Y">
                              <FormattedMessage id="economy" />
                            </option>
                            <option value="W">
                              <FormattedMessage id="premium_economy" />
                            </option>
                            <option value="C">
                              <FormattedMessage id="business" />
                            </option>
                            <option value="F">
                              <FormattedMessage id="first_class" />
                            </option>
                          </select>
                        </div>
                        <div className="text-center">
                          <AppButton
                            btnText={<FormattedMessage id="done_btn" />}
                            onClick={handlePassengersSelection}
                            variant="secondary"
                            className="px-4"
                          />
                        </div>
                      </div>
                    )}
                  </Overlay>
                </Col>
              </Row>
            </div>
            <Row>
              <Col
                lg={9}
                md={9}
                sm={12}
                xs={12}
                className="d-flex  flex-column overflow-visible"
              >
                <div className="searchtype-container d-flex w-100 flex-1">
                  <AppRadioInput
                    id="normal"
                    name="searchtype"
                    labelText={<FormattedMessage id="regular" />}
                    value="normal"
                    onChange={handleChange}
                    checked={search.flightsearchrequest.searchtype === 'normal'}
                  />
                  <AppRadioInput
                    id="student"
                    name="searchtype"
                    labelText={<FormattedMessage id="student_fare" />}
                    value="student"
                    onChange={handleChange}
                    checked={
                      search.flightsearchrequest.searchtype === 'student'
                    }
                  />
                  <AppRadioInput
                    id="seniorcitizen"
                    name="searchtype"
                    labelText={<FormattedMessage id="senior_citizen" />}
                    value="seniorcitizen"
                    onChange={handleChange}
                    checked={
                      search.flightsearchrequest.searchtype === 'seniorcitizen'
                    }
                  />
                  <AppRadioInput
                    id="defenceonly"
                    name="searchtype"
                    labelText="Armed Force "
                    value="defenceonly"
                    onChange={handleChange}
                    checked={
                      search.flightsearchrequest.searchtype === 'defenceonly'
                    }
                  />
                  {}
                  <AppRadioInput
                    id="seriesfares"
                    name="searchtype"
                    labelText="Series Fare"
                    value="seriesfares"
                    onChange={handleChange}
                    checked={
                      search.flightsearchrequest.searchtype === 'seriesfares'
                    }
                  />
                  <AppCheckBox
                    id="nonstopsearch"
                    name="nonstopsearch"
                    labelText={<FormattedMessage id="non_stop_flight" />}
                    // value="nonStop"
                    onChange={handleNonStopSelect}
                    checked={
                      search.flightsearchrequest.nonstopsearch === 'true'
                    }
                  />
                </div>
                {showAdvanceSearch && (
                  <div className="advanced-search-content">
                    <AppSelect
                      name="prefcarrier"
                      className="app-select"
                      placeholder=""
                      selectWidth="250px"
                      label={<FormattedMessage id="preferred_airline" />}
                      selectedValue={search.flightsearchrequest.prefcarrier}
                      options={PREF_AIRLINE_OPTIONS}
                      onSelect={(dataObj, name) => {
                        handleUpdateSearchState(name, dataObj.value);
                      }}
                      isClearable={false}
                    />
                  </div>
                )}
              </Col>
              <Col lg={3} md={3} sm={12} xs={12}>
                <div className="d-flex flex-column justify-content-center gap-1 mt-2">
                  {/* <AppButton
                  btnText={<FormattedMessage id="flight_search_btn" />}
                  variant="primary"
                  onClick={handleFlightSearch}
                /> */}
                  <AppLink
                    linkText={<FormattedMessage id="advanced_search" />}
                    variant="primary"
                    className="fs-12 text-center fw-600"
                    onClick={() => setShowAdvanceSearch((prev) => !prev)}
                  />
                </div>
              </Col>
            </Row>
          </div>
          <div className="d-flex justify-content-center service-search-btn">
            <AppButton
              btnText="Search Flights"
              className="searchButton"
              variant="primary"
              onClick={handleFlightSearch}
            />
          </div>
        </div>
      ) : (
        <div className="flight-landing-page_container">
          <div className="flight-landing-page_search">
            <div className="flight-landing-page_search_container">
              <div className="flight-landing-page_search_radio-container d-flex gap-3">
                <div className="d-flex gap-2">
                  <div
                    className={`travel-class ${
                      search.flightsearchrequest.journeytype === 'OneWay'
                        ? 'selected-travel-class'
                        : ''
                    }`}
                    onClick={() =>
                      handleChangejourneytype('journeytype', 'OneWay')
                    }
                  >
                    OneWay
                  </div>
                  <div
                    className={`travel-class ${
                      search.flightsearchrequest.journeytype === 'RoundTrip'
                        ? 'selected-travel-class'
                        : ''
                    }`}
                    onClick={() =>
                      handleChangejourneytype('journeytype', 'RoundTrip')
                    }
                  >
                    RoundTrip
                  </div>
                  {appConfig?.hasMultiCity && (
                    <div
                      className={`travel-class ${
                        search.flightsearchrequest.journeytype === 'MultiCity'
                          ? 'selected-travel-class'
                          : ''
                      }`}
                      onClick={() =>
                        handleChangejourneytype('journeytype', 'MultiCity')
                      }
                    >
                      Multi city
                    </div>
                  )}
                  {/* <div
                    className={`travel-class ${
                      search.flightsearchrequest.journeytype === 'groupbooking'
                        ? 'selected-travel-class'
                        : ''
                    }`}
                    onClick={() => navigate('/flight/agent-support')}
                  /> */}
                </div>
              </div>
              <Row className="flight-landng-page_search_request">
                <Col lg={9} md={9} sm={12} xs={12}>
                  {search.flightsearchrequest.journeytype !== 'MultiCity' ? (
                    <Row>
                      <Col lg={6} md={6} sm={12} xs={12}>
                        <Row className="spacing-1 mb-sm-0 mb-2 gap-2">
                          <Col
                            lg={6}
                            md={6}
                            sm={6}
                            xs={12}
                            className="position-relative border-bottom-2"
                          >
                            <AppAsyncSelect
                              placeholder=""
                              name="origin"
                              components={{ Option: AirportOption }}
                              selectedValue={originAirportRef.current}
                              loadOptionsFn={loadAirportSuggestions}
                              defaultOptions={defaultAirportsList}
                              onSelect={handleAirportSelect}
                              label={formattedMessage('depart_from')}
                              menuWidth="300px !important"
                              height={isMobileWidth() ? '54px' : undefined}
                              padding={isMobileWidth() ? '8px 14px' : undefined}
                              selectedTab="flight"
                            />
                            <small className="validation-error">
                              {errors.origin && errors.origin}
                            </small>
                          </Col>
                          <div className="d-flex justify-content-center origin-swap">
                            <button onClick={handleSwap}>
                              <MdOutlineSwapVert
                                style={{
                                  color: '#ed5121',
                                }}
                              />
                            </button>
                          </div>
                          <Col
                            lg={6}
                            md={6}
                            sm={6}
                            xs={12}
                            className="border-bottom-2"
                          >
                            <AppAsyncSelect
                              placeholder=""
                              name="destination"
                              components={{ Option: AirportOption }}
                              selectedValue={destinationAirportRef.current}
                              loadOptionsFn={loadAirportSuggestions}
                              defaultOptions={defaultAirportsList}
                              onSelect={handleAirportSelect}
                              label={formattedMessage('going_to')}
                              menuWidth="300px !important"
                              menuStartFromRight={isMobileWidth()}
                              height={isMobileWidth() ? '54px' : undefined}
                              padding={isMobileWidth() ? '8px 14px' : undefined}
                              selectedTab="flight"
                            />
                            <small className="validation-error">
                              {errors.destination && errors.destination}
                            </small>
                          </Col>
                        </Row>
                      </Col>
                      <Col lg={6} md={6} sm={12} xs={12}>
                        <Row className="spacing-1 mb-sm-0 mb-2 d-flex justify-content-between">
                          <Col
                            lg={6}
                            md={6}
                            sm={6}
                            xs={5}
                            className="border-bottom-2"
                          >
                            <AppDatePicker
                              customClassName="app-landing-datepicker"
                              label={formattedMessage('depart_date')}
                              labelClassName="landing-datepicker-label"
                              valueClassName="fs-14 fw-600"
                              minDate={getNewDate(TODAY_DATE)}
                              monthsShown={12}
                              dateFormat="dd MMM yy"
                              selectedDate={
                                search.flightsearchrequest.onwarddate
                              }
                              onChange={(date) =>
                                handleDateChange(date, 'onwarddate')
                              }
                              showDay={isMobileWidth() ? false : true}
                            />
                            <small className="validation-error">
                              {errors.onwarddate && errors.onwarddate}
                            </small>
                          </Col>
                          <Col
                            lg={2}
                            md={2}
                            sm={2}
                            xs={2}
                            className="d-flex justify-content-center align-items-center fs-18  grey-color"
                          >
                            <MdCalendarMonth />
                          </Col>
                          <Col
                            lg={6}
                            md={6}
                            sm={6}
                            xs={5}
                            className="border-bottom-2"
                          >
                            <AppDatePicker
                              customClassName="app-landing-datepicker"
                              label={formattedMessage('return_date')}
                              placeholder={formattedMessage('return_date')}
                              labelClassName="landing-datepicker-label d-flex justify-content-end"
                              valueClassName="fs-14 fw-600 d-flex justify-content-end"
                              minDate={
                                search.flightsearchrequest.onwarddate === ''
                                  ? getNewDate(TODAY_DATE)
                                  : search.flightsearchrequest.onwarddate
                              }
                              monthsShown={12}
                              dateFormat="dd MMM yy"
                              selectedDate={
                                search.flightsearchrequest.returndate
                              }
                              onChange={(date) =>
                                handleDateChange(date, 'returndate')
                              }
                              showDay={
                                search.flightsearchrequest.returndate !== '' &&
                                !isMobileWidth()
                              }
                            />
                            <small className="validation-error">
                              {errors.returndate && errors.returndate}
                              {errors.onwaredDateAfterReturnDate &&
                                errors.onwaredDateAfterReturnDate}
                            </small>
                            {/* {search.flightsearchrequest.returndate !== '' && (
                          <div
                            className="clear-return-date"
                            onClick={handleClearReturnDate}
                          >
                            X
                          </div>
                        )} */}
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  ) : (
                    <Row className="spacing-8">
                      {search.flightsearchrequest.multiCitySearch.map(
                        (d, index) => (
                          <React.Fragment key={index}>
                            <Col lg={6} md={6} sm={12} xs={12}>
                              <Row className="spacing-1 mb-sm-0 mb-2">
                                <Col
                                  lg={6}
                                  md={6}
                                  sm={6}
                                  xs={12}
                                  className="position-relative border-bottom-2"
                                >
                                  <AppAsyncSelect
                                    placeholder=""
                                    name="origin"
                                    components={{ Option: AirportOption }}
                                    selectedValue={d.selectedOrigin}
                                    loadOptionsFn={loadAirportSuggestions}
                                    defaultOptions={defaultAirportsList}
                                    onSelect={(airport, name) =>
                                      handleMultiCityChange(
                                        airport,
                                        name,
                                        index,
                                      )
                                    }
                                    label={formattedMessage('depart_from')}
                                    menuWidth="320px !important"
                                    height={
                                      isMobileWidth() ? '54px' : undefined
                                    }
                                    padding={
                                      isMobileWidth() ? '8px 14px' : undefined
                                    }
                                    selectedTab="flight"
                                  />
                                  <small className="validation-error">
                                    {errors.multiCity[index]?.origin &&
                                      errors.multiCity[index].origin}
                                  </small>
                                </Col>
                                <Col
                                  lg={6}
                                  md={6}
                                  sm={6}
                                  xs={12}
                                  className="border-bottom-2"
                                >
                                  <AppAsyncSelect
                                    placeholder=""
                                    name="destination"
                                    components={{ Option: AirportOption }}
                                    selectedValue={d.selectedDestination}
                                    loadOptionsFn={loadAirportSuggestions}
                                    defaultOptions={defaultAirportsList}
                                    onSelect={(airport, name) =>
                                      handleMultiCityChange(
                                        airport,
                                        name,
                                        index,
                                      )
                                    }
                                    label={formattedMessage('going_to')}
                                    menuWidth="320px !important"
                                    height={
                                      isMobileWidth() ? '54px' : undefined
                                    }
                                    padding={
                                      isMobileWidth() ? '8px 14px' : undefined
                                    }
                                    menuStartFromRight={isMobileWidth()}
                                    selectedTab="flight"
                                  />
                                  <small className="validation-error">
                                    {errors.multiCity[index]?.destination &&
                                      errors.multiCity[index].destination}
                                  </small>
                                </Col>
                              </Row>
                            </Col>
                            <Col lg={6} md={6} sm={12} xs={12} className="pb-3">
                              <Row>
                                <Col
                                  lg={6}
                                  md={6}
                                  sm={12}
                                  xs={6}
                                  className="border-bottom-2"
                                >
                                  <AppDatePicker
                                    customClassName="app-landing-datepicker"
                                    label={formattedMessage('depart_date')}
                                    labelClassName="landing-datepicker-label"
                                    minDate={
                                      index === 0
                                        ? getNewDate(TODAY_DATE)
                                        : search.flightsearchrequest
                                            .multiCitySearch[index - 1]
                                            .onwarddate
                                    }
                                    monthsShown={isMobileWidth() ? 12 : 2}
                                    dateFormat="dd MMM yy"
                                    selectedDate={d.onwarddate}
                                    onChange={(date) =>
                                      handleMultiCityChange(
                                        date,
                                        'onwarddate',
                                        index,
                                      )
                                    }
                                    showDay={isMobileWidth() ? false : true}
                                  />
                                  <small className="validation-error">
                                    {errors.multiCity[index]?.onwarddate &&
                                      errors.multiCity[index].onwarddate}
                                  </small>
                                </Col>
                                <Col
                                  lg={6}
                                  md={6}
                                  sm={6}
                                  xs={6}
                                  className="d-flex gap-2 fw-600 align-items-center justify-content-end"
                                >
                                  {search.flightsearchrequest.multiCitySearch
                                    .length > 2 &&
                                    [0, 1].indexOf(index) === -1 && (
                                      <AppButton
                                        btnText="Remove"
                                        onClick={() =>
                                          onRemoveMultiCityRow(index)
                                        }
                                        variant="outlined"
                                      />
                                    )}
                                  {index === 0 && (
                                    <AppButton
                                      onClick={onAddMultiCityRow}
                                      btnText="Add City"
                                      variant="secondary"
                                    />
                                  )}
                                </Col>
                              </Row>
                            </Col>
                          </React.Fragment>
                        ),
                      )}
                    </Row>
                  )}
                </Col>
                <Col
                  lg={3}
                  md={3}
                  sm={12}
                  xs={12}
                  className="mobile-landingpag"
                >
                  <div className="traveler-container">
                    <div className="gap-2">
                      <div className="fs-10 pb-2">Adult (&gt;12 years)</div>
                      <div className="d-flex">
                        <div
                          className="addremove addremove-left-radius"
                          onClick={() => handleRemovePassengers('numadults')}
                        >
                          -
                        </div>
                        <div className="paxtype">
                          {search.flightsearchrequest.numadults}
                        </div>
                        <div
                          className="addremove addremove-right-radius"
                          onClick={() => handleAddPassengers('numadults')}
                        >
                          +
                        </div>
                      </div>
                    </div>
                    <div className="gap-2">
                      <div className="fs-10 pb-2">Child (2-12 years)</div>
                      <div className="d-flex">
                        <div
                          className="addremove addremove-left-radius"
                          onClick={() => handleRemovePassengers('numchildren')}
                        >
                          -
                        </div>
                        <div className="paxtype">
                          {search.flightsearchrequest.numchildren}
                        </div>
                        <div
                          className="addremove addremove-right-radius"
                          onClick={() => handleAddPassengers('numchildren')}
                        >
                          +
                        </div>
                      </div>
                    </div>
                    <div className="gap-2">
                      <div className="fs-10 pb-2">Infant (0-2 years)</div>
                      <div className="d-flex">
                        <div
                          className="addremove addremove-left-radius"
                          onClick={() => handleRemovePassengers('numinfants')}
                        >
                          -
                        </div>
                        <div className="paxtype">
                          {search.flightsearchrequest.numinfants}
                        </div>
                        <div
                          className="addremove addremove-right-radius"
                          onClick={() => handleAddPassengers('numinfants')}
                        >
                          +
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                <Col
                  lg={3}
                  md={3}
                  sm={12}
                  xs={12}
                  className="mobile-landingpag mt-3"
                >
                  <div className="fs-10 pb-2">Travel Class</div>
                  <div className="d-flex gap-1 overflow-auto">
                    <div
                      className={`travel-class ${
                        search.flightsearchrequest.prefclass === 'Y'
                          ? 'selected-travel-class'
                          : ''
                      }`}
                      onClick={() => handlePrefClassChange('Y')}
                    >
                      Economy
                    </div>
                    <div
                      className={`travel-class ${
                        search.flightsearchrequest.prefclass === 'W'
                          ? 'selected-travel-class'
                          : ''
                      }`}
                      onClick={() => handlePrefClassChange('W')}
                    >
                      Premium Economy
                    </div>
                    <div
                      className={`travel-class ${
                        search.flightsearchrequest.prefclass === 'C'
                          ? 'selected-travel-class'
                          : ''
                      }`}
                      onClick={() => handlePrefClassChange('C')}
                    >
                      Business
                    </div>
                    <div
                      className={`travel-class ${
                        search.flightsearchrequest.prefclass === 'F'
                          ? 'selected-travel-class'
                          : ''
                      }`}
                      onClick={() => handlePrefClassChange('F')}
                    >
                      First Class
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <Row>
              <Col
                lg={9}
                md={9}
                sm={12}
                xs={12}
                className="d-flex  flex-column overflow-auto"
              >
                <div className="searchtype-container d-flex w-100 flex-1">
                  <AppRadioInput
                    id="normal"
                    name="searchtype"
                    labelText={<FormattedMessage id="regular" />}
                    value="normal"
                    onChange={handleChange}
                    checked={search.flightsearchrequest.searchtype === 'normal'}
                  />
                  <AppRadioInput
                    id="student"
                    name="searchtype"
                    labelText={<FormattedMessage id="student_fare" />}
                    value="student"
                    onChange={handleChange}
                    checked={
                      search.flightsearchrequest.searchtype === 'student'
                    }
                  />
                  <AppRadioInput
                    id="seniorcitizen"
                    name="searchtype"
                    labelText={<FormattedMessage id="senior_citizen" />}
                    value="seniorcitizen"
                    onChange={handleChange}
                    checked={
                      search.flightsearchrequest.searchtype === 'seniorcitizen'
                    }
                  />
                  <AppRadioInput
                    id="defenceonly"
                    name="searchtype"
                    labelText="Armed Force "
                    value="defenceonly"
                    onChange={handleChange}
                    checked={
                      search.flightsearchrequest.searchtype === 'defenceonly'
                    }
                  />
                  <AppRadioInput
                    id="seriesfares"
                    name="searchtype"
                    labelText="Series Fare"
                    value="seriesfares"
                    onChange={handleChange}
                    checked={
                      search.flightsearchrequest.searchtype === 'seriesfares'
                    }
                  />
                  <AppCheckBox
                    id="nonstopsearch"
                    name="nonstopsearch"
                    labelText={<FormattedMessage id="non_stop_flight" />}
                    // value="nonStop"
                    onChange={handleNonStopSelect}
                    checked={
                      search.flightsearchrequest.nonstopsearch === 'true'
                    }
                  />
                </div>
              </Col>
              {/* <Col lg={3} md={3} sm={12} xs={12}>
              <div className="d-flex flex-column justify-content-center gap-1 mt-2">
                <AppButton
                  btnText={<FormattedMessage id="flight_search_btn" />}
                  variant="primary"
                  onClick={handleFlightSearch}
                />
                <AppLink
                  linkText={<FormattedMessage id="advanced_search" />}
                  variant="primary"
                  className="fs-12 text-center fw-600"
                  onClick={() => setShowAdvanceSearch((prev) => !prev)}
                />
              </div>
            </Col> */}
            </Row>
            {showAdvanceSearch && (
              <div className="advanced-search-content mt-3">
                <AppSelect
                  name="prefcarrier"
                  className="app-select"
                  placeholder=""
                  selectWidth="250px"
                  label={<FormattedMessage id="preferred_airline" />}
                  selectedValue={search.flightsearchrequest.prefcarrier}
                  options={PREF_AIRLINE_OPTIONS}
                  onSelect={(dataObj, name) => {
                    handleUpdateSearchState(name, dataObj.value);
                  }}
                  isClearable={false}
                />
              </div>
            )}
          </div>
          <div className="d-flex flex-column gap-2 justify-content-center service-search-btn">
            <AppButton
              btnText="Search Flights"
              variant="primary"
              onClick={handleFlightSearch}
            />
            <AppLink
              linkText={<FormattedMessage id="advanced_search" />}
              variant="primary"
              className="fs-12 text-center fw-600"
              onClick={() => setShowAdvanceSearch((prev) => !prev)}
            />
          </div>
        </div>
      )}
    </div>
  );
}
FlightLandingPage.defaultProps = {
  previousSearchRequest: undefined,
  onModifySearch: () => {},
  isModifySearch: false,
};

FlightLandingPage.propTypes = {
  previousSearchRequest: PropTypes.object,
  onModifySearch: PropTypes.func,
  isModifySearch: PropTypes.bool,
};

export default FlightLandingPage;
